
FWS.Api = {

  _memoryCache: {},

  adminId(id) {
    return typeof id === 'string' && id.includes('gid://') ? parseInt(id.split('/').pop()) : id
  },

  storefrontId(type, id) {
    return id.toString().includes('gid://') ? id : `gid://shopify/${type}/${id}`
  },

  async storefrontRequest(query) {
    const cached = FWS.Api._memoryCache[query]
    return cached || fetch(`https://${FWS.config.shopDomain}/api/2024-07/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': FWS.config.storefrontAccessToken
      },
      body: JSON.stringify({ query })
    }).then(resp => resp.json())
      .then(resp => {
        if (resp.errors) {
          console.log('GraphQL Error: ', resp.errors)
        }
        FWS.Api._memoryCache[query] = resp
        return resp
      })
  }
}
